module.exports = "<div class=\"wrapper\">\n\n  <div class=\"bar\">\n    <olapic-logo></olapic-logo>\n    <input ng-model=\"search.name\" placeholder=\"Search ...\"/>\n    <logout></logout>\n  </div>\n  <div class=\"breadcrumbs\">\n    <button ng-click=\"$ctrl.goToCreate()\"><span>Create Network</span></button> <span><a href=\"#!/networks\">All Networks</a></span>\n  </div>\n  <div class=\"content\">\n    <cn-list networks=\"$ctrl.networks\" class=\"list\" search=\"search.name\"></cn-list>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/cn/cnmain.html
// module id = 36
// module chunks = 0